import React from "react";

export default function CreateAutom() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="19" height="19" rx="2.5" fill="#152941" stroke="#4F6E90"/>
            <path d="M5.94995 10H13.55" stroke="#4F6E90" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M9.75 6L9.75 14" stroke="#4F6E90" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>

    );
}
